import { IPage, ITitlePage } from '../../interfaces';
import {
    setBillingSystemForcedUpdateTime,
    setCompaniesForcedUpdateTime,
    setInvoicesForcedUpdateTime,
    setMonthlyOrdersForcedUpdateTime,
} from '../../middleware';

export const billingPages: IPage[] = [
    {
        id: 'B0003-BillingOrdersList',
        componentName: 'BillingOrdersList',
        title: 'Order List' as ITitlePage, // ToDo: 29.11.2024 - add translation
        forcedUpdate: setBillingSystemForcedUpdateTime,
        isActive: true,
        isDefault: true,
        isMenu: true,
        menuIcon: 'AccountBookOutlined',
        url: '/billing/orders',
    },
    {
        id: 'B0003-BillingNewOrder',
        componentName: 'BillingNewOrder',
        title: 'New Order',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'AccountBookOutlined',
        url: '/billing/orders/new',
        roleRight: ['USER'],
    },
    {
        id: 'B0003-BillingShowOrder',
        componentName: 'BillingShowOrder',
        title: 'Order',
        isActive: true,
        menuIcon: 'AccountBookOutlined',
        url: '/billing/orders/:id',
    },
    {
        id: 'B0004-BillingCompaniesList',
        componentName: 'BillingCompaniesList',
        title: 'Companies',
        forcedUpdate: setCompaniesForcedUpdateTime,
        isActive: true,
        isMenu: true,
        menuIcon: 'BankOutlined',
        url: '/billing/companies',
    },
    {
        id: 'B0004-BillingCompanyNew',
        componentName: 'BillingCompanyNew',
        title: 'New Company',
        companyTypeDenied: ['MNO'],
        isActive: true,
        isMenu: false,
        menuIcon: 'PlusSquareOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/companies/new',
    },
    {
        id: 'B0004-BillingCompany',
        componentName: 'BillingCompany',
        title: 'Company',
        companyTypeDenied: ['MNO'],
        isActive: true,
        isMenu: false,
        menuIcon: 'EyeOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/companies/:id',
    },
    {
        id: 'B0004-BillingCompanyEdit',
        componentName: 'BillingCompanyEdit',
        title: 'Edit Company',
        companyTypeDenied: ['MNO'],
        isActive: true,
        isMenu: false,
        menuIcon: 'FormOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/companies/:id/edit',
    },
    {
        id: 'B0004-BillingInvoicesList',
        componentName: 'InvoicesList',
        title: 'Invoices',
        forcedUpdate: setInvoicesForcedUpdateTime,
        isActive: true,
        isMenu: true,
        menuIcon: 'AuditOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/invoices',
    },
    {
        id: 'B0004-BillingInvoice',
        componentName: 'Invoice',
        title: 'Invoice',
        isActive: true,
        isMenu: false,
        menuIcon: 'AuditOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/invoices/:id',
    },
    {
        id: 'B0004-MonthlyOrdersList',
        componentName: 'MonthlyOrdersList',
        title: 'MonthlyOrders' as ITitlePage,
        forcedUpdate: setMonthlyOrdersForcedUpdateTime,
        isActive: true,
        isMenu: true,
        menuIcon: 'EuroOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/monthly_orders',
    },
    {
        id: 'B0004-MonthlyOrder',
        componentName: 'MonthlyOrder',
        title: 'MonthlyOrder' as ITitlePage,
        isActive: true,
        isMenu: false,
        menuIcon: 'EuroOutlined',
        roleRight: ['ADMIN'],
        url: '/billing/monthly_orders/:id',
    },
    {
        id: 'B0004-GeneralNRC',
        componentName: 'GeneralNRC',
        title: 'General NRCs',
        isActive: true,
        isMenu: true,
        roleRight: ['ADMIN'],
        menuIcon: 'AccountBookOutlined',
        url: '/billing/general_nrcs',
    },
    {
        id: '0000-MyMenu',
        componentName: 'My',
        isActive: true,
        url: '#',
    },
    {
        id: 'B0002-Profile-view',
        componentName: 'Profile',
        isActive: true,
        url: '#',
    },
    {
        id: 'B0002-Profile-edit',
        componentName: 'ProfileEdit',
        isActive: true,
        url: '#',
    },
    {
        id: 'B0002-MyCompany-view',
        componentName: 'MyCompany',
        isActive: true,
        url: '#',
    },
    {
        id: 'B0002-MyCompany-edit',
        componentName: 'MyCompanyEdit',
        isActive: true,
        url: '#',
    },
    {
        id: 'B0002-MyAlarms',
        componentName: 'MyAlarms',
        isActive: true,
        url: '#',
    },
];
